import classNames from 'classnames';
import styles from './index.module.scss';
import {Checkbox} from '@baidu/luffy';
import Icon, {IconSize} from '@/components/Icon';
import {getDocFillSvgByType} from '@/utils/docType';
import {updateByDocGuid} from '../treeUtils';
import {STATUS} from '@/Constant';
import EllipsisTooltip from '@/components/EllipsisTooltip';

interface nodeProps {
    node: any;
    currentDocList: any[];
    loadingStatus: string;
    updateDocNum: (val: string) => void;
}

export default function DocNode(props: nodeProps) {
    const {node, currentDocList, loadingStatus, updateDocNum} = props;


    function getIcon(item: any) {
        return <Icon
            svg={getDocFillSvgByType(item.type as number | undefined)}
            size={IconSize.XL}
            className={styles.teamIconSize}
            noSpace
        />;
    }

    function handleOpenLink(event: any) {
        event.stopPropagation();
        event.preventDefault();
        if (!node?.url) {
            return;
        }
        window.open(node.url);
    }

    return <div
        className={styles.customNodeRoot}
        title=""
    >
        <div className={classNames(styles.customNodeLeft, node.disabled && styles.customNodeDisabled)}>
            <Checkbox
                className={classNames(styles.checkbox)}
                checked={node.disabled ? false : node.checked}
                onClick={() => {
                    if (loadingStatus === STATUS.confirmLoading) {
                        return;
                    }
                    updateDocNum(node.checked ? 'del' : 'add');
                    updateByDocGuid(currentDocList, node.docGuid, !node.checked);
                }}
                disabled={node.disabled}
                size={'sm'}
            />
            {getIcon(node)}
            <EllipsisTooltip
                tooltipClassName={styles.docNameToolTip}
                placement={'bottom-start'}
                tooltipContent={node.name}
                mouseEnterDelay={400}
            >
                <span
                    onClick={(e) => {
                        handleOpenLink(e);
                    }}
                    className={styles.nodeName}
                    title=""
                >{node.name}</span>
            </EllipsisTooltip>
        </div>
        {
            node.disabled ? <div className={styles.customNodeRight}>
                暂无权限授权
            </div> : ''
        }
    </div>;
}
